export const metersToFeet = (meters: number): number => {
  return meters * 3.28084;
};

export const feetToMeters = (feet: number): number => {
  return feet * 0.3048;
};

export const squareFeetToSquareMeters = (squareFeet: number): number => {
  return squareFeet * 0.092903;
};

/**
 * Get the length of the hypotenuse given a length and width
 */
export const getHypotenuse = function(length: number, width: number): number {
  return Math.sqrt(Math.pow(length, 2) + Math.pow(width, 2));
};

export const convertDegreesToRadians = function(degrees: number): number {
  return degrees * (Math.PI / 180);
};

export const convertRadiansToDegress = function(radians: number): number {
  return radians / (Math.PI / 180);
};

export const roundTo3sf = function(num: number) : number {
  return Math.round(num * 1000) / 1000
}

/** 
 * Get the difference between two degree angles. Always returns a positive 
 * number.
 */
export const getDifferenceBetweenAngles = function(
  degA: number, 
  degB: number
): number{
  var temp = ((degA + 360) % 360) - ((degB + 360) % 360) 
  if (temp < 0){
    temp = temp * -1
  }
  return temp
}